import { StoryblokComponent } from "@storyblok/react";
import { CustomSiteConfigModel } from "../Models/CustomSiteConfigModel";
import NotificationDisplay from "../Notification/Notification";

const NotificationStripNav: React.FC<{
  customSiteConfig: CustomSiteConfigModel;
}> = ({ customSiteConfig }) => {
  return (
    <div className="notification-strip-nav">
      <NotificationDisplay />
      {customSiteConfig?.content?.NavigationStrip &&
      customSiteConfig?.content?.NavigationStrip?.length > 0
        ? customSiteConfig.content.NavigationStrip.map((blokk: any) => {
            if (!blokk.content) {
              return null;
            }
            return (
              <StoryblokComponent
                blok={blokk.content}
                key={blokk.content._uid}
              />
            );
          })
        : null}

      {customSiteConfig?.content?.nav &&
      customSiteConfig?.content?.nav?.length > 0
        ? customSiteConfig.content.nav.map((blokk: any) => (
            <StoryblokComponent
              blok={blokk}
              key={blokk._uid}
              footer={customSiteConfig?.content?.footer}
            />
          ))
        : null}
    </div>
  );
};

export default NotificationStripNav;
